<div class="container customer-search" pos-relative
  *ngIf="!rootService.activeCustTab.wrapUpData.unknownCallerWrapupPage">

  <section *ngIf="false" class="error-wrapper hide">
    <f-alert variant="error">
      Unable to retrieve Customer information. Try again with Customer Search.
    </f-alert>
  </section>

  <div class="row cc-panel">
    <div class="col-md-12 col-lg-7">
      <div class="row">
        <div class="col-md-12">
          <h3 class="section-heading" *ngIf="!rootService.isLiveChat">
            <span *ngIf="rootService.displayRedIcon ">
              <i class="fa fa-phone red"></i>
            </span>

            {{ pageTitle() }} <span *ngIf="!rootService.displayRedIcon"> (inactive)</span><span *ngIf="checkDialing()">
              (Dialing)</span>
          </h3>

          <h3 class="section-heading" *ngIf="rootService.isLiveChat">
            <span>
              <i class="fa-solid fa-comment red"></i>
            </span>
            Chat
          </h3>
        </div>
      </div>

      <form [formGroup]="customerSearchForm" autocomplete="off" id="txtCustomerForm">
        <!-- @author Vamsi.Pamidala disableDropdown function is created for common use both customer search pages -->
        <div class="row row-bottom-space">
          <div class="col-md-6">
            <app-alight-drop-down [group]="customerSearchForm" [controlName]="'clientId'" [required]="true"  (change)="onClientChange($event)"
              description="clientName" [disable]="rootService.disableDropdown()" label="Client" [value]="'clientId'"
              [list]="customerService.clients">
            </app-alight-drop-down>
          </div>

          <div class="col-md-4" *ngIf='false'>
            <app-alight-drop-down [group]="customerSearchForm" [controlName]="'customerType'" value="fieldValue"
              description="fieldValueDescription" label="Customer Type" [list]="customers"></app-alight-drop-down>
          </div>
        </div>

        <div class="row row-bottom-space">
          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box" [ngClass]="{ 'error-border': invalid }">
              <mat-label>Last Name (Required)</mat-label>
              <input matInput formControlName="lastName" autocomplete="new-password" id="lastName"
                (focus)="onFocus($event)" (keyup)="onKeyUp($event, 'lastName')" />
              <mat-error *ngIf="
              errorHandling('lastName', 'required') ||
              errorHandling('lastName', 'pattern')
            ">
                <i class="fa-solid fa-circle-xmark"></i>
                {{ errorMsg.lastName }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" id="firstName" (focus)="onFocus($event)" />
            </mat-form-field>
          </div>

        </div>
        <div class="row row-bottom-space">
          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box" [ngClass]="{ 'error-border': invalid }">
              <mat-label>Date of Birth (MM/DD/YYYY)</mat-label>
              <input matInput formControlName="dateOfBirth" id="dateOfBirth" (keyup)="onKeyUp($event, 'dateOfBirth')"
                (focus)="onFocus($event)" />
              <mat-error *ngIf="errorHandling('dateOfBirth', 'pattern')">
                <i class="fa-solid fa-circle-xmark"></i>
                {{ errorMsg.dateOfBirth }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box" [ngClass]="{ 'error-border': invalid }">
              <mat-label>National ID (Last 4)</mat-label>
              <input matInput formControlName="nationalId" maxlength="4" id="nationalId" (focus)="onFocus($event)"
                (keyup)="onKeyUp($event, 'nationalId')" />
              <mat-error *ngIf="
              errorHandling('nationalId', 'minlength') ||
              errorHandling('nationalId', 'pattern')
            ">
                <i class="fa-solid fa-circle-xmark"></i>
                {{ errorMsg.nationalId }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">

          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box error-border">
              <mat-label>Employee ID</mat-label>
              <input matInput formControlName="employeeId" id="employeeId" (focus)="onFocus($event)" />
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Postal Code</mat-label>
              <input matInput formControlName="postalCode" id="postalCode" (focus)="onFocus($event)" />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-button-controls">
              <f-button text="Clear all" type="button" variant="action" (buttonClicked)="clearAll()"></f-button>
              <f-button text="Search" type="submit" variant="progressive" uuid="txtSearch" disabled="{{
              customerSearchForm.value.clientId == 0 ||
                !customerSearchForm.value.clientId
            }}" (buttonClicked)="submit()">
              </f-button>
              <f-button text="Unknown Caller" type="button" variant="progressive"
                (buttonClicked)="showUnknowncallerTab()"></f-button>

            </div>
          </div>
        </div>
      </form>
    </div>

  <div class="col-md-12 col-lg-5">
    <f-data-card class="pos-relative clientInfo">
      <h2 class="heading">Client Info</h2>
      <section class="error-wrapper" *ngIf="cusAccService.checkDefaultPinLoadApiFail()" >
        <f-alert variant="error">
          <p> There was a problem loading the data. <button class="btn-alert" (click)="cusAccService.getDefaultPin()">Try again</button> </p>
        </f-alert>
      </section>
      <section  class="error-wrapper" *ngIf="cusAccService.checkCreateUpdateDefaultPinApiFail()">
        <f-alert variant="error">
          Unable to update default pin please try again on clicking of hollow pin icon
        </f-alert>
      </section>
      <section class="no-result" *ngIf="rootService.displayNoDataMsgOnClientInfoCard(clientId)">                 
          <p> No data available </p>                  
      </section>

      <app-carousel *ngIf="!rootService.displayNoDataMsgOnClientInfoCard(clientId)" [cardComponents]="rootService.clientInfoCard.clientInfoVSClientIdMap[clientId]"></app-carousel>
     </f-data-card>
  </div>
  </div>


  <div class="row">
    <div class="col-md-4">
      <h3 class="search-result">Customer Search Results</h3>
    </div>
    <div class="col-md-8">
      <h3 class="display-result" *ngIf="totalRecords > 0 && totalRecords <= 50">
        Currently displaying
        <strong>{{ alightTable?.totalCount }}</strong> results
      </h3>
      <!-- <h3 class="display-reult" *ngIf="totalRecords == 0">No results found</h3> -->
    </div>
  </div>
  <app-alight-table [dataSource]="dataSource" [totalRecords]="totalRecords" [tableName]="'unidendifiedCall'"
    [gridColumns]="Columns" [rowPerPage]="10" (rowSelection)="rowSelection($event)" (disableButtons)="(false)"
    [hideReplaceAddButton]="true"></app-alight-table>

  <app-loader *ngIf="rootService.custSearchLoader" [loaderType]="loaderType"
    [loaderMsg]="rootService.showCustSearchLoaderMsg"></app-loader>
</div>



<app-unknown-caller (dataRetain)="dataRetainFromUnknownCaller()" *ngIf="rootService.activeCustTab.wrapUpData.unknownCallerWrapupPage"></app-unknown-caller>